export default __webpack_public_path__ + "static/media/no-amount.c6f0735b.svg";